export default __webpack_public_path__ + "static/badge-enter-extended-75ab2283451a9e04ee385cb3fbb8f853.webp";